import { SwitcherDivider as CarbonSwitcherDivider } from "@carbon/react";
import styled from "styled-components";
export const SwitcherDivider = styled(CarbonSwitcherDivider) `
	margin: auto;
	width: calc(100% - 30px);
`;
